import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QuoteGenerator from "../components/QuoteGenerator";
import "../assets/css/AddCustomer.css";

function QuoteGeneratorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerData, type } = location.state || {};

  return (
    <div className="addcustomer-container quote-generator-page-container">
      <QuoteGenerator
        standalone
        isOpen={true}
        onClose={() => navigate(-1)}
        customerData={customerData}
        type={type || "client"}
        hideBackInHeader
      />
    </div>
  );
}

export default QuoteGeneratorPage;
